import { InfoListStepByStep } from './InfoListStepByStep';

export type { TypeInfoListStepByStepProps } from './types';
export default InfoListStepByStep;
